import { useState } from "react";
import { useNavigate } from "react-router-dom";
import client, { formatApiError } from "../lib/api";
import { trackLead } from "../lib/tracking";

export default function LeadMagnetForm({ dark = true, source = "lead-magnet" }) {
  const [form, setForm] = useState({ name: "", email: "", privacy: false });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!form.privacy) {
      setError("Devi accettare la Privacy Policy per scaricare la guida.");
      return;
    }
    setLoading(true);
    try {
      await client.post("/leads", { ...form, source });
      trackLead(source);
      navigate("/grazie");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = `w-full rounded-lg px-4 py-3.5 text-base border transition-colors focus:outline-none focus:ring-2 focus:ring-oro/60 ${
    dark
      ? "bg-nero/40 border-panna/20 text-panna placeholder:text-panna/40"
      : "bg-panna border-nero/20 text-nero placeholder:text-nero/40"
  }`;

  return (
    <form onSubmit={submit} data-testid="lead-magnet-form" className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <input
          data-testid="lead-form-name"
          type="text"
          required
          minLength={2}
          placeholder="Il tuo nome"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          className={inputCls}
        />
        <input
          data-testid="lead-form-email"
          type="email"
          required
          placeholder="La tua email"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          className={inputCls}
        />
      </div>
      <label className="flex items-start gap-3 cursor-pointer text-left">
        <input
          data-testid="lead-form-privacy"
          type="checkbox"
          checked={form.privacy}
          onChange={(e) => setForm({ ...form, privacy: e.target.checked })}
          className="mt-1 h-4 w-4 accent-[#B0832F]"
        />
        <span className={`text-xs leading-relaxed ${dark ? "text-panna/70" : "text-nero/70"}`}>
          Ho letto e accetto la <a href="/privacy-policy" className="underline text-oro">Privacy Policy</a> e
          acconsento al trattamento dei miei dati per ricevere la guida gratuita e comunicazioni da Dentro il Calice.
        </span>
      </label>
      {error && <p data-testid="lead-form-error" className="text-sm text-oro-light">{error}</p>}
      <button
        data-testid="lead-magnet-form-submit"
        type="submit"
        disabled={loading}
        className={`w-full sm:w-auto rounded-full px-10 py-4 font-medium transition-all duration-300 disabled:opacity-60 ${
          dark
            ? "bg-nero text-oro border border-oro hover:bg-nero-light"
            : "bg-bordeaux text-panna hover:bg-bordeaux-dark"
        }`}
      >
        {loading ? "Invio in corso…" : "Scarica la guida gratuita"}
      </button>
    </form>
  );
}
